import Typography from '@/components/Typography';
import { MasterTranslation, TextStyles } from '@/constants';
import { useGlobalState } from '@/hooks';
import { AffiliateBadgeType } from '@/modules/pmt/interfaces';
import type { FC, HTMLAttributes } from 'react';
import { Container } from './ProductBadge.styles';

interface ProductBadgeProps {
  type: AffiliateBadgeType;
  label?: string;
}

const badgeTranslationKeys: Record<AffiliateBadgeType, MasterTranslation> = {
  [AffiliateBadgeType.AmazonChoice]: MasterTranslation.AffiliateBadgeAmazonChoice,
  [AffiliateBadgeType.Prime]: MasterTranslation.AffiliateBadgePrime,
  [AffiliateBadgeType.Coupon]: MasterTranslation.AffiliateBadgeCoupon,
  [AffiliateBadgeType.LimitedTimeDeal]: MasterTranslation.AffiliateBadgeLimitedTimeDeal,
};

const ProductBadge: FC<ProductBadgeProps & HTMLAttributes<HTMLDivElement>> = ({ type, label, ...rest }) => {
  const { t } = useGlobalState();
  const displayLabel = label || t(badgeTranslationKeys[type]);

  return (
    <Container type={type} {...rest}>
      <Typography variant={TextStyles['Heading 6']}>{displayLabel}</Typography>
    </Container>
  );
};

export default ProductBadge;
